import styled from 'styled-components';
import React, { useState, useEffect } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ContainerBackground = '#f3f0ff';
var ProgressBackground = '#572CCE';
var ReadProgressBarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  position: fixed;\n  width: 100%;\n  transition: height 0.3s ease;\n  z-index: 300;\n  height: ", ";\n  background: ", ";\n  overflow: hidden;\n"], ["\n  display: flex;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  position: fixed;\n  width: 100%;\n  transition: height 0.3s ease;\n  z-index: 9999;\n  height: ", ";\n  background: ", ";\n  overflow: hidden;\n"])), function (props) { return (props.hide ? '0px' : '10px'); }, function (props) { return props.color || ContainerBackground; });
var Bar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  left: 0px;\n  background: ", ";\n  top: 0px;\n  bottom: 0px;\n  width: 100%;\n  transform: translateX(-100%);\n  transition: transform 0.1s ease;\n  will-change: transform;\n"], ["\n  position: relative;\n  left: 0px;\n  background: ", ";\n  top: 0px;\n  bottom: 0px;\n  width: 100%;\n  transform: translateX(-100%);\n  transition: transform 0.1s ease;\n  will-change: transform;\n"])), function (props) { return props.color || ProgressBackground; });

var ReadProgressBar = function (props) {
    var _a = useState(0), progress = _a[0], setProgress = _a[1];
    var trackScrollEvent = function () {
        var _a = props.attachTo.current.getBoundingClientRect(), top = _a.top, height = _a.height;
        var progress = (top / (height - window.innerHeight)) * 100;
        var translateValue = progress < -100 ? 0 : -100 - progress;
        setProgress(translateValue < -100 ? -100 : top > 0 ? 0 : translateValue);
    };
    useEffect(function () {
        if (props.attachTo && props.attachTo.current && props.attachTo.current.getBoundingClientRect()) {
            window.addEventListener('scroll', trackScrollEvent);
        }
        return function () {
            window.removeEventListener('scroll', trackScrollEvent);
        };
    }, [props.attachTo]);
    return (
        React.createElement(ReadProgressBarContainer, { color: props.backgroundColor, hide: progress === -100 || progress === 0 },
        React.createElement(Bar, { color: props.color, style: { transform: "translateX(" + progress + "%)" } }),
        React.createElement("div", {style: {position: "fixed", right: "12px", top: "20px", width: "50px", color: "#572CCE", fontWeight: "700", fontSize: "14px" }}, Math.round(progress + 100) + "%")
        )    
    );
};
var templateObject_1, templateObject_2;

export default ReadProgressBar;
